const footerLinks = [
  {
    title: 'HubbleHQ',
    links: [
      {
        url: '/about',
        label: 'About Us',
        target: '_self',
      },
      {
        url: '/host',
        label: 'List Your Office Space',
        target: '_self',
      },
      {
        url: '/team',
        label: 'Meet The Team',
        target: '_self',
      },
      {
        url: '/jobs',
        label: 'Jobs',
        target: '_self',
      },
      {
        url: '/blog',
        label: 'Blog',
      },
      {
        url: '/guides',
        label: 'Guides',
      },
      {
        url: '/press',
        label: 'Press',
        target: '_self',
      },
      {
        url: '/legals',
        label: 'Terms and Conditions',
        target: '_self',
      },
      {
        url: '/privacy-policy',
        label: 'Privacy Policy',
        target: '_self',
      },
      {
        url: '/sitemap',
        label: 'Site Map',
      },
    ],
  },
  {
    title: 'Explore Offices',
    links: [
      {
        url: '/office-space-london',
        label: 'Office Space in London',
        target: '_self',
      },
      {
        url: '/office-space-london/shoreditch',
        label: 'Office Space in Shoreditch',
        target: '_self',
      },
      {
        url: '/office-space-london/soho',
        label: 'Office Space in Soho',
        target: '_self',
      },
      {
        url: '/office-space-london/london-bridge-station',
        label: 'Office Space in London Bridge',
        target: '_self',
      },
      {
        url: '/guides/rent-desk/london',
        label: 'Rent a Desk in London',
      },
      {
        url: '/guides/rent-office/london',
        label: 'Rent an Office in London',
      },
      {
        url: '/office-space-london',
        label: 'Search',
        target: '_self',
      },
    ],
  },
  {
    title: 'Connect',
    links: [
      {
        url: 'https://www.facebook.com/HubbleHQ/',
        label: 'Facebook',
        target: '_blank',
      },
      {
        url: 'https://www.instagram.com/hubblehq/',
        label: 'Instagram',
        target: '_blank',
      },
      {
        url: 'https://twitter.com/hubble',
        label: 'Twitter',
        target: '_blank',
      },
      {
        url: 'https://www.linkedin.com/company/3519114',
        label: 'LinkedIn',
        target: '_blank',
      },
    ],
  },
];

export default footerLinks;
